function parseArray(value) {
  if (!value) return [];

  if (Array.isArray(value)) {
    return value.filter(Boolean);
  }

  if (typeof value !== "string") {
    return [];
  }

  const trimmed = value.trim();
  if (!trimmed) return [];

  if (trimmed.startsWith("[")) {
    try {
      const parsed = JSON.parse(trimmed);
      return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
    } catch (_e) {
      return [];
    }
  }

  return trimmed
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);
}

function getSelectedHandlerValues(vsEl) {
  if (typeof vsEl.getSelectedOptions === "function") {
    return (vsEl.getSelectedOptions() || [])
      .map((item) => item && item.value)
      .filter(Boolean);
  }

  return parseArray(vsEl.value || vsEl.dataset.saveddata || "");
}

function syncSelectedHandlers(vsEl) {
  const allOptions = parseArray(vsEl.dataset.options || "[]");
  const selectedValues = getSelectedHandlerValues(vsEl);
  const nextValue =
    selectedValues.length === 0 || selectedValues.length === allOptions.length
      ? ""
      : selectedValues.join(",");

  window.__crmHandlers = nextValue;

  const hiddenInput = document.getElementById("handler-filter-vs_input");
  if (hiddenInput) {
    hiddenInput.value = nextValue;
  }
}

export function initCrmHandlerFilter(root) {
  const scope = root && root.querySelector ? root : document;
  const vsEl =
    scope.querySelector("#handler-filter-vs") ||
    (scope !== document ? document.querySelector("#handler-filter-vs") : null);

  if (!vsEl) return;

  syncSelectedHandlers(vsEl);

  if (vsEl.dataset.crmHandlerFilterInstalled === "1") return;
  vsEl.dataset.crmHandlerFilterInstalled = "1";

  vsEl.addEventListener("change", () => {
    syncSelectedHandlers(vsEl);

    const globalFilter = document.querySelector('[name="global_filter"]');
    if (globalFilter && typeof window.hxEmitter === "function") {
      window.hxEmitter(globalFilter);
    }
  });
}
